import styled from 'styled-components';
import tw from 'tailwind-styled-components';
const Wrapper = tw.div`
lg:w-1/2 w-[100%] justify-center
`;

export default Wrapper;
